<template>
	<el-dialog :title="titleVale" v-model="dialogVisible" width="30%" :before-close="handleClose">
		<el-form :model="form" :rules="rules" ref="ruleForm">
			<el-form-item label="科目:" prop="name" label-width="100px">
				<el-input v-model="form.name" autocomplete="off"></el-input>
			</el-form-item>
			<div class="buttom-box">
				<el-button type="primary" class="Tijiao" @click="submitForm('ruleForm')">提交</el-button>
				<el-button @click="handleClose">返回</el-button>
			</div>
		</el-form>

	</el-dialog>
</template>
<script>
	import {
		subjectUpdate,
		subjectAdd
	} from '@/assets/api/schoollog'
	import {
		gradeList,
		findClassList
	} from '@/assets/api/renyuan';
	// import { ElMessage } from 'element-plus'

	export default {
		components: {},
		props: ['reviseItem', 'objLookTeacher',"titleValue"],
		data() {
			return {
				dialogVisible: true,
				form: {
					id: "",
					name: '',
				},
				titleVale: '',
				rules: {
					name: [{
						required: true,
						message: '标题',
						trigger: 'change'
					}],
				}
			}
		},
		created() {
			if (JSON.stringify(this.reviseItem) != '{}') {
				this.form.name = this.reviseItem.name
			}
			this.titleVale = this.titleValue;
		},
		mounted() {
			console.log(this.objLookTeacher);
		},
		methods: {
			handleClose() {
				this.$emit('backClick')
			},
			
			submitForm(ruleForm) {
				this.$refs[ruleForm].validate((valid) => {
					if (valid) {
						this.addClick()
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			
			addClick() {
				console.log('提交');
				if (JSON.stringify(this.reviseItem) != '{}') {
					this.reviseItem.name = this.form.name;
					subjectUpdate(this.reviseItem).then((res) => {
						this.$message({
							message: '修改成功',
							type: 'success'
						});
						this.handleClose();
					}).catch((err) => {
						this.$message.error('发布信息失败');
					})
				} else {
					let params = {
						schoolId: this.objLookTeacher.schoolId,
						name: this.form.name
					}
					subjectAdd(params).then((res) => {
						this.$message({
							message: '添加成功！',
							type: 'success'
						});
						this.handleClose()
					}).catch((err) => {
						this.$message({
							type: 'error',
							message: err.response.data.msg
						});
					})
				}
			}
		}
	}
</script>
<style scoped lang="scss">
	.Tijiao {
		// background-color: #1BC896;
	}

	/deep/ {
		.el-input--small .el-input__wrapper {
			height: 35px;
			line-height: 35px;
			text-align: center;
			width: 280px;
		}

		.el-input__inner {
			// width: 10px !important;
		}

		.buttom-box {
			// text-align: center;
			margin-left: 180px;

		}

		.el-form-item--small {
			width: 70% !important;
		}

		.el-button--small {
			width: 60px !important;
			height: 35px !important;
			// color: #1BC896;


		}

		.el-select--small .el-select__wrapper {
			height: 35px;
		}

		.el-form-item--small .el-form-item__label {
			height: 35px;
			line-height: 35px;
		}
	}
</style>